<template>
  <header class="header">
    <div class="header-info">
      <a href="https://cpayfoundation.com">
        <i class="icon-logo"></i>
      </a>
    </div>
  </header>
</template>

<script>
// import SelectLang from '@/components/SelectLang'

export default {
  name: 'v-header',
  components: {
    // SelectLang
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue